import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useAlert } from 'utils/alert';
import { RouteComponentProps } from 'react-router';
import { Button } from 'react-bootstrap';
import queryString from 'query-string';
import { axius, func, images, mapFx, types } from 'utils';
import {
	GoBack,
	Header,
	Loading,
	MapsInputAutocomplete,
	MapsInputAutocompletePlaces,
	TabsOffset,
	Touchable,
} from 'components';
import { _store, _update } from '_Store';

interface StateProps {
	title?: string;
	verify?: boolean;
	asComponent?: boolean;

	onFinish?: () => void;
}
interface Props extends RouteComponentProps, types.StateProps, StateProps {}
const Location: React.FC<Props> = (props) => {
	const { asComponent } = props;
	const {
		__data: { location },
	} = _store.useState();

	const v = location;
	const zoom = 17;

	const [presentAlert] = useAlert();

	const [step, setStep] = React.useState(1);
	const [places, setPlaces] = React.useState<types.Address[]>([]);

	React.useEffect(() => {
		if (props.history.location.search) {
			const qs = queryString.parse(props.history.location.search);
			const qwert = JSON.parse(atob(qs.ordercr as string));
			axius
				.post('search', {
					city: qwert.store.address.city,
					latitude: qwert.store.address.lat,
					longitude: qwert.store.address.lng,
					resultTypes: ['stores'],
					delivery_optionsX: [location.option],
				})
				.then((res) => {
					if (res.status === 201) {
						_update.data('location', {
							option: 'delivery',
							radius: 30,
							address: qwert.store.address,
						});
						_update.data('activeStore', res.stores[0]);
					}
					func.redirect('/');
				});
			return;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.history.location.search]);

	const getMyCurrentLocation = () => {
		mapFx.myCurrentLocation().then((address) => {
			if (address) {
				_update.data('location', { ...v, address: { ...address, zoom } });
			} else {
				presentAlert(
					"We couldn't get your current location. Please allow location access or search for your address."
				);
			}
		});
	};

	const submit = () => {
		if (step === 1) {
			func.delStorage('after_login');
			props.onFinish ? props.onFinish() : func.redirect('/');
		} else {
			if (v.address.x && v.address.y) {
				setStep(step + 1);
			} else {
				presentAlert(`Please choose a location`);
			}
		}
	};

	const hasHeader = !!(!asComponent && props.location.pathname !== '/location');
	const hasLocation = !!(
		location.address.iso &&
		location.address.x &&
		location.address.y
	);

	if (props.history.location.search) {
		return <Loading />;
	}

	return (
		<IonPage id="Location">
			<Header {...props} showAddress={false} />

			<IonContent fullscreen={false}>
				<div
					id="Location"
					className={hasHeader ? 'content c-small p-3' : 'p-3'}
				>
					{step > 1 && (
						<div className="mb-4">
							<GoBack
								{...props}
								onClick={() => {
									setStep(step - 1);
								}}
							/>
						</div>
					)}

					{/* ::: step 1 */}
					<div
						className={`animate__animated animate__fadeIn animate__faster mb-4 ${step !== 1 ? 'hide' : ''}`}
					>
						<h4 className="fs-16 fw-600 primary d-flex align-items-center">
							<img
								src={images.Location2}
								alt="Your location - Republic Dash"
								style={{ height: 20 }}
							/>
							<div className="ml-2">Where Are You?</div>
						</h4>
						<div className="mb-3">
							We use your location to show nearby outlets available for pick up
							or delivery.
						</div>
						{hasLocation && v.address.name && (
							<div className="mb-3 mt-5s primary">
								<div className="text-muted mb-2">Current Location</div>
								{/* <img src={images.Location2} alt="Your location - Republic Dash" className="img-fluid mr-1" style={{ height: 18 }} /> */}
								<span className="addressName">{v.address.name}</span>
							</div>
						)}
						<MapsInputAutocomplete onChange={setPlaces} />
						<Touchable onClick={getMyCurrentLocation}>
							<div className="py-1 small text-muted">
								Use my current location
							</div>
						</Touchable>
						<div>&nbsp;</div>
						<MapsInputAutocompletePlaces addresses={[...places]} />
					</div>

					<div>&nbsp;</div>
					{/*  footer */}
					<div className={`${hasHeader ? 'footer' : ''}`}>
						<Button
							variant="secondary btn-block btn-md"
							disabled={!(v.address.x && v.address.y && v.address.name)}
							onClick={submit}
						>
							Continue
						</Button>
					</div>
				</div>
				<TabsOffset />
			</IonContent>
		</IonPage>
	);
};

export default Location;
